/* 4Snelshop refresh: mega menu behaviour, scroll reveal, small UI helpers. */
(function () {
  'use strict';

  var root = document.documentElement;
  root.classList.add('sx-js');

  /* ---------- Mega menu ---------- */

  function initMega() {
    var items = document.querySelectorAll('[data-sx-mega]');
    if (!items.length) return;

    var dim = document.createElement('div');
    dim.className = 'sx-dim';
    document.body.appendChild(dim);

    var canHover = window.matchMedia('(hover: hover)').matches;

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-sx-mega-trigger]');
      var panel = item.querySelector('[data-sx-mega-panel]');
      var openTimer;
      var closeTimer;

      function open() {
        clearTimeout(closeTimer);
        if (item.classList.contains('is-open')) return;
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        dim.classList.add('is-on');
      }

      function close() {
        clearTimeout(openTimer);
        if (!item.classList.contains('is-open')) return;
        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        dim.classList.remove('is-on');
      }

      if (canHover) {
        // Small delays so the menu does not flicker when the pointer passes over it.
        item.addEventListener('mouseenter', function () {
          clearTimeout(closeTimer);
          openTimer = setTimeout(open, 90);
        });
        item.addEventListener('mouseleave', function () {
          clearTimeout(openTimer);
          closeTimer = setTimeout(close, 160);
        });
      }

      // Touch and keyboard: first activation opens, second follows the link.
      trigger.addEventListener('click', function (event) {
        if (!item.classList.contains('is-open')) {
          event.preventDefault();
          open();
        }
      });

      trigger.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          open();
          var first = panel.querySelector('a');
          if (first) first.focus();
        }
      });

      item.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && item.classList.contains('is-open')) {
          close();
          trigger.focus();
        }
      });

      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) close();
      });

      document.addEventListener('click', function (event) {
        if (!item.contains(event.target)) close();
      });
    });
  }

  /* ---------- Scroll reveal ---------- */

  function initReveal() {
    var nodes = document.querySelectorAll('[data-sx-reveal]:not(.is-in)');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (node) {
        node.classList.add('is-in');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    nodes.forEach(function (node) {
      observer.observe(node);
    });
  }

  /* ---------- Tabs (product rail) ---------- */

  function initTabs() {
    document.querySelectorAll('[data-sx-tabs]').forEach(function (wrap) {
      if (wrap.dataset.sxReady) return;
      wrap.dataset.sxReady = 'true';

      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(wrap.querySelectorAll('[role="tabpanel"]'));
      var marker = wrap.querySelector('[data-sx-tab-marker]');

      function moveMarker(tab) {
        if (!marker || !tab) return;
        marker.style.width = tab.offsetWidth + 'px';
        marker.style.transform = 'translateX(' + tab.offsetLeft + 'px)';
      }

      function select(tab, focus) {
        tabs.forEach(function (other) {
          var active = other === tab;
          other.setAttribute('aria-selected', active ? 'true' : 'false');
          other.tabIndex = active ? 0 : -1;
        });
        panels.forEach(function (panel) {
          var active = panel.id === tab.getAttribute('aria-controls');
          panel.hidden = !active;
          if (active) {
            panel.classList.remove('is-switching');
            // Restart the entrance animation of the cards.
            void panel.offsetWidth;
            panel.classList.add('is-switching');
          }
        });
        moveMarker(tab);
        if (focus) tab.focus();
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          select(tab);
        });
        tab.addEventListener('keydown', function (event) {
          var next;
          if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
          if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
          if (next) {
            event.preventDefault();
            select(next, true);
          }
        });
      });

      var current = wrap.querySelector('[role="tab"][aria-selected="true"]') || tabs[0];
      moveMarker(current);
      window.addEventListener('resize', function () {
        moveMarker(wrap.querySelector('[role="tab"][aria-selected="true"]'));
      });
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          moveMarker(wrap.querySelector('[role="tab"][aria-selected="true"]'));
        });
      }
    });
  }

  /* ---------- Horizontal rails with arrow buttons ---------- */

  function initRails() {
    document.querySelectorAll('[data-sx-rail]').forEach(function (wrap) {
      if (wrap.dataset.sxReady) return;
      wrap.dataset.sxReady = 'true';

      var track = wrap.querySelector('[data-sx-rail-track]');
      var prev = wrap.querySelector('[data-sx-rail-prev]');
      var next = wrap.querySelector('[data-sx-rail-next]');
      if (!track || !prev || !next) return;

      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
        wrap.classList.toggle('has-overflow', max > 2);
      }

      function step(direction) {
        track.scrollBy({ left: direction * track.clientWidth * 0.85, behavior: 'smooth' });
      }

      prev.addEventListener('click', function () {
        step(-1);
      });
      next.addEventListener('click', function () {
        step(1);
      });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Count bubbles: hide when zero ---------- */

  function initCounts() {
    // The theme's cart and wishlist scripts rewrite these bubbles, so watch them.
    document.querySelectorAll('.header__actions_btn_cart_num').forEach(function (bubble) {
      function sync() {
        var count = parseInt(bubble.textContent, 10);
        bubble.classList.toggle('is-zero', !count);
      }
      sync();
      new MutationObserver(sync).observe(bubble, { childList: true, characterData: true, subtree: true });
    });
  }

  function init() {
    initMega();
    initReveal();
    initTabs();
    initRails();
    initCounts();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: sections are re-rendered without a page load.
  document.addEventListener('shopify:section:load', function () {
    initReveal();
    initTabs();
    initRails();
  });
})();
